import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const LikeIcon = ({
  height = normalize(16),
  width = normalize(16),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 14 14"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.1226 2.11727C6.20752 1.92922 6.39473 1.80835 6.60107 1.80835C7.11491 1.80835 7.60937 2.00915 7.97523 2.36921C8.34138 2.72954 8.54864 3.22007 8.54864 3.73334V5.075H10.705C10.9162 5.07311 11.1255 5.11617 11.3187 5.20152C11.513 5.28733 11.6867 5.41397 11.8274 5.57321C11.9681 5.73248 12.0724 5.92052 12.1326 6.12449C12.1928 6.32849 12.2072 6.54312 12.1748 6.75335L12.1747 6.75415L11.5204 10.9533C11.5204 10.9534 11.5204 10.9536 11.5203 10.9538C11.4663 11.3035 11.286 11.6205 11.015 11.8472C10.7448 12.0731 10.4025 12.1948 10.0507 12.1916H3.28173C2.89365 12.1916 2.51981 12.04 2.24287 11.7674C1.96566 11.4946 1.80835 11.1228 1.80835 10.7333V7.46665C1.80835 7.07714 1.96566 6.70532 2.24287 6.4325C2.51981 6.15996 2.89365 6.00832 3.28173 6.00832H4.36535L6.1226 2.11727ZM5.2293 6.64637L6.91506 2.91364C7.03598 2.95768 7.14663 3.02695 7.23873 3.11759C7.40615 3.28235 7.49864 3.50401 7.49864 3.73334V5.6C7.49864 5.88995 7.73369 6.125 8.02364 6.125H10.7076L10.7134 6.12496C10.7761 6.12426 10.8379 6.137 10.8945 6.162C10.9511 6.187 11.0008 6.22351 11.0405 6.26846C11.0802 6.31338 11.109 6.3657 11.1255 6.42159C11.142 6.47732 11.1459 6.53571 11.1371 6.59288C11.1372 6.59274 11.1371 6.59302 11.1371 6.59288L10.4828 10.7925L10.4827 10.7933C10.468 10.8885 10.4186 10.9771 10.3413 11.0418C10.2637 11.1067 10.1635 11.1428 10.059 11.1417L5.2293 11.1416V6.64637ZM4.1793 11.1416V7.05832H3.28173C3.16676 7.05832 3.05815 7.10335 2.97937 7.18088C2.90088 7.25812 2.85835 7.36109 2.85835 7.46665V10.7333C2.85835 10.8389 2.90088 10.9418 2.97937 11.0191C3.05815 11.0966 3.16676 11.1416 3.28173 11.1416H4.1793Z"
      fill="#848694"
    />
  </Svg>
);

export default LikeIcon;
